module.exports = __webpack_public_path__ + "img/1.45a3079b.jpg";